/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import { Vocabulary } from "../../Utils/Vocabulary";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  CostModel,
  VendorModel,
} from "../../Utils/Models";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Delete } from "@material-ui/icons";
import { useLocation } from "react-router-dom";

const purchesType = ["Purchase"];
const documentType = ["Invoice"];
type ManualCostProp = {
  manualCost: CostModel;
  file: File | undefined;
  setManualCost: Dispatch<SetStateAction<CostModel>>;
  setFile: Dispatch<SetStateAction<File | undefined>>;
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function AutomaticCost(prop: ManualCostProp) {
  const { manualCost, file, setManualCost, setFile } = prop;
  const [vendors, setVendors] = useState<Array<VendorModel>>([]);

  const cache = localStorage.getItem("cache");
  const cacheJSON = cache ? JSON.parse(cache) : {};
  const { taxRates } = cacheJSON;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  useEffect(() => {
    const getVendors = async () => {
      const data = await getData(`${urlEnum.customers}/type/vendors`);
      setVendors(data.data.result);
    };
    getVendors();
  }, []);

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ marginTop: 10, alignItems: "center" }}
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            size="small"
            id="type"
            freeSolo={true}
            options={purchesType}
            disabled={false}
            value={manualCost.type}
            getOptionLabel={(option: any) => option}
            isOptionEqualToValue={(option: any, value: any) => option === value}
            onChange={(event: any, value: any) => {
              setManualCost({
                ...manualCost,
                type: value,
              });
            }}
            renderInput={(params: any) => (
              <TextValidator
                {...params}
                fullWidth
                label={Vocabulary.type}
                value={manualCost.type}
                variant="outlined"
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                label={Vocabulary.date}
                defaultValue={dayjs()}
                value={dayjs(manualCost.date)}
                onChange={(value) => {
                  if (value) {
                    setManualCost({
                      ...manualCost,
                      date: value.toDate(),
                    });
                  }
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            size="small"
            id="companyName"
            name="companyName"
            label={Vocabulary.description}
            fullWidth
            variant="outlined"
            value={manualCost.description}
            onChange={(event: any) => {
              setManualCost({
                ...manualCost,
                description: event.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            type="number"
            size="small"
            id="companyName"
            name="companyName"
            label={Vocabulary.totalWithTax}
            fullWidth
            variant="outlined"
            value={manualCost.payment.totalWithTax}
            onChange={(event: any, value: any) => {
              setManualCost({
                ...manualCost,
                payment: {
                  ...manualCost.payment,
                  totalWithTax: value,
                },
              });
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextField
            size="small"
            fullWidth
            value={manualCost.payment.taxValue}
            label={Vocabulary.taxValue}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            size="small"
            id="type"
            freeSolo={true}
            options={taxRates}
            disabled={false}
            value={manualCost.payment.tax}
            getOptionLabel={(option: any) => option.name}
            isOptionEqualToValue={(option: any, value: any) => option === value}
            onChange={(event: any, value: any) => {
              setManualCost({
                ...manualCost,
                payment: {
                  ...manualCost.payment,
                  tax: value,
                },
              });
            }}
            renderInput={(params: any) => (
              <TextValidator
                {...params}
                fullWidth
                label={Vocabulary.vat}
                value={manualCost.payment.tax}
                variant="outlined"
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            size="small"
            id="type"
            freeSolo={true}
            options={vendors}
            disabled={false}
            value={manualCost.vendor}
            getOptionLabel={(option: any) => option.name}
            isOptionEqualToValue={(option: any, value: any) => option === value}
            onChange={(event: any, value: any) => {
              setManualCost({
                ...manualCost,
                vendor: value,
              });
            }}
            renderInput={(params: any) => (
              <TextValidator
                {...params}
                fullWidth
                label={Vocabulary.vendor}
                value={manualCost.vendor}
                variant="outlined"
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Autocomplete
            size="small"
            id="type"
            freeSolo={true}
            options={documentType}
            disabled={false}
            value={manualCost.documentType}
            getOptionLabel={(option: any) => option}
            isOptionEqualToValue={(option: any, value: any) => option === value}
            onChange={(event: any, value: any) => {
              setManualCost({
                ...manualCost,
                documentType: value,
              });
            }}
            renderInput={(params: any) => (
              <TextValidator
                {...params}
                fullWidth
                label={Vocabulary.documentType}
                value={manualCost.documentType}
                variant="outlined"
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextValidator
            type="number"
            size="small"
            id="companyName"
            name="companyName"
            label={Vocabulary.number}
            fullWidth
            variant="outlined"
            value={manualCost.number}
            onChange={(event: any, value: any) => {
              setManualCost({
                ...manualCost,
                number: event.target.value,
              });
            }}
          />
        </Grid>
        {type === "manual" && (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
              >
                {Vocabulary.uploadFile}
                <VisuallyHiddenInput
                  type="file"
                  accept=".pdf,.doc,.jpg,.png"
                  onChange={(event) => {
                    if (event.target.files) {
                      // eslint-disable-next-line prefer-destructuring
                      const originalFile = event.target.files[0];
                      const timestamp = Date.now();

                      const newName = `${timestamp}_${originalFile.name}`;
                      const renamedFile = new File([originalFile], newName, {
                        type: originalFile.type,
                        lastModified: originalFile.lastModified,
                      });

                      setFile(renamedFile);
                      setManualCost({
                        ...manualCost,
                        file: "",
                      });
                    }
                  }}
                />
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {file && file.name !== "" && (
                <>
                  <Button
                    onClick={() => {
                      setFile(undefined);
                    }}
                  >
                    <Delete style={{ color: "red" }} />
                  </Button>
                  {file.name}
                </>
              )}
              {manualCost.file !== "" && (
                <>
                  <Button
                    onClick={() => {
                      setManualCost({
                        ...manualCost,
                        file: "",
                      });
                    }}
                  >
                    <Delete style={{ color: "red" }} />
                  </Button>
                  {manualCost.file}
                </>
              )}
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
